
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5ZM12.7456 17.1538L8.59446 14.1077H6V10.0462H8.59446L12.7456 7V17.1538ZM14.5617 9.45859L14.9658 9.85393C16.2267 11.0877 16.2267 13.0155 14.9658 14.2492L14.5617 14.6446L13.7536 13.8539L14.1576 13.4585C14.9723 12.6615 14.9723 11.4417 14.1576 10.6446L13.7536 10.2493L14.5617 9.45859ZM16.0665 8.08774L16.4705 8.48308C18.5098 10.4783 18.5098 13.7262 16.4705 15.7215L16.0665 16.1168L15.2584 15.3261L15.6624 14.9308C17.2554 13.3722 17.2554 10.8323 15.6624 9.27376L15.2584 8.87842L16.0665 8.08774Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowoverallsituationaudioFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
